function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "bootstrap",
  d: "M1573.1,1382.5c-43.8-33.2-101.8-49.8-173.8-49.8h-362.5v415.5h356.2c32.5,0,63.6-3.2,93.3-9.5 c29.7-6.4,55.8-17,78.4-31.8c22.6-14.8,40.6-35,54.1-60.4s20.1-57.9,20.1-97.5C1638.8,1471.2,1616.9,1415.7,1573.1,1382.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "bootstrap",
  d: "M1520,1063.4c38.2-28.3,57.2-74.2,57.2-137.8c0-35.3-6.4-64.3-19.1-86.9c-12.7-22.6-29.7-40.3-50.9-53 c-21.2-12.7-45.6-21.6-73.1-26.5c-27.6-5-56.2-7.4-85.9-7.4h-311.6v354l0,0h337.1C1433.1,1105.8,1481.9,1091.7,1520,1063.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "bootstrap",
  d: "M2177.6,0H322.4C144.3,0,0,144.3,0,322.4v1855.3v0c0,178,144.3,322.4,322.4,322.4h1855.3 c178.1,0,322.4-144.3,322.4-322.4V322.4C2500,144.3,2355.7,0,2177.6,0z M1927.1,1766.2c-29.7,55.8-69.6,101.4-119.8,136.7 c-50.2,35.3-107.4,61.5-171.7,78.4s-130.4,25.4-198.2,25.4H703.9V493.2h712.3c72.1,0,137.8,6.4,197.2,19.1 c59.4,12.7,110.2,33.6,152.6,62.5c42.4,29,75.3,67.5,98.6,115.5c23.3,48.1,35,107.4,35,178.1c0,76.3-17.3,139.9-51.9,190.8 c-34.6,50.9-85.9,92.6-153.7,125.1c93.3,26.9,162.9,73.8,208.8,141c45.9,67.1,68.9,148,68.9,242.7 C1971.6,1644.3,1956.8,1710.4,1927.1,1766.2z"
}));

function SvgBootstrap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2500 2500",
    style: {
      enableBackground: "new 0 0 2500 2500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootstrap);
export default __webpack_public_path__ + "static/media/bootstrap.48d293af.svg";
export { ForwardRef as ReactComponent };